/**
* Current Refinements Module Position
* 
* Only runs on mobile
*/

custom.currentRefinementsPosition = (() => {

	const idNames = [
		"current-refined-values",
		"current-refined-values-pillow",
		"current-refined-values-throw",
		"current-refined-values-art",
		"current-refined-values-poufs"
	];
	const desktopSurfix = "--desktop";
	const inFilterSurfix = "--mobile-in";
	const outsideSurfix = "--mobile-out";
	const buttonSurfix = "--button";

	const filterOpen = "js-search-filter-open";

	/**
	 * Force Repaint of Header because of OSX Safari Rendering Bug
	 * https://martinwolf.org/before-2018/blog/2014/06/force-repaint-of-an-element-with-javascript/
	 */
	function triggerRepaint(id="") {
		var el = document.getElementById(id);

		el.style.display = 'none';
		el.offsetHeight; // no need to store this anywhere, the reference is enough
		el.style.display = 'block';
	}

	function positionHandler(id="") {
		if (!custom.utils.getDeviceSizeName().includes("small")) return $(`#${id}`).prependTo(`#${id}${desktopSurfix}`);
		($("body").attr("class").includes(filterOpen)) ? $(`#${id}`).prependTo(`#${id}${inFilterSurfix}`) : $(`#${id}`).prependTo(`#${id}${outsideSurfix}`);
		triggerRepaint(id);
	}

	function init() {
		idNames.forEach((id) => {
			if ($(`#${id}`).length > 0) {
				positionHandler(id);
				window.addEventListener("resize", () => { positionHandler(id); });
				$(`.${id}${buttonSurfix}`).on("click", () => { positionHandler(id); });
			};
		});
	}

	return {
		init
	}

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/current-refinements-position.js